import { format, utcToZonedTime } from 'date-fns-tz';

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const timeformat = (t: string) => `${format(utcToZonedTime(t, timezone), 'dd-MMM-yyyy HH:mm:ss')} ${timezone}`;
